// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cb-4";
export var closeButton = "_cb-6";
export var dismissButton = "_cb-3";
export var editImageWithAiContainer = "_cb-8";
export var imageUploadWrapper = "_cb-7";
export var misspelledWord = "_cb-5";
export var spellCheckContainer = "_cb-2";
export var spin = "_cb-1";
export var spinning = "_cb-0";